import Logo from "./../../assets/logo.svg"
import classes from "./AppLogo.module.css";

const AppLogo = () => {
    return (
        <div className={classes.AppLogo}>
            {/*<Logo/>*/}
            <img src={Logo}/>
        </div>
    );
};

export default AppLogo;
